module.exports = __webpack_public_path__ + "static/media/banner_mclaren_mid.228ab967.jpg";